import { render, staticRenderFns } from "./BoothList.vue?vue&type=template&id=87d0c96a&scoped=true&"
import script from "./BoothList.vue?vue&type=script&lang=js&"
export * from "./BoothList.vue?vue&type=script&lang=js&"
import style0 from "./BoothList.vue?vue&type=style&index=0&id=87d0c96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d0c96a",
  null
  
)

export default component.exports